import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { StatsSection } from '../common/stats-section';
import { BenchmarkingExplainer } from '../../../../../../common/react/components/benchmarking';
import { KeyStatsAndPerformanceMain } from './components/KeyStatsAndPerformanceMain';
import { getTranslation } from '../../../../../../common/react/utils/translations';
import { useDispatch, useSelector } from 'react-redux';
import { EmptyState } from '../../../../../../common/react/components/EmptyState';
import { Loader } from '../../../../../../common/react/components/Loader';

export const KeyStatsAndPerformance = ( { seasonId } ) => {
    const dispatch = useDispatch();
    const playerId = new URLSearchParams( location.search ).get( 'playerId' );
    const playerData = useSelector( state => PULSE.app.redux.selectors.statsplayerprofile.item( state, playerId ) );
    const [ topSeasonData, setTopSeasonData ] = useState( null );
    const [ topCareerData, setTopCareerData ] = useState( null );

    useEffect( () => {
        // Initialise the player profile in the redux store
        dispatch(
            PULSE.app.redux.actions.statsplayerprofile
                .ADD_PLAYER_PROFILE
                .request( { seasonId, playerId } )
        );

        // Fetch top season performance data
        PULSE.app.common.misApi.request( {
            url: `${ PULSE.app.environment.cfsApi }/statsCentre/player/best/season?playerId=${ playerId }`,
            callback: response => setTopSeasonData( response )
        } );

        // Fetch top career performance data
        PULSE.app.common.misApi.request( {
            url: `${ PULSE.app.environment.cfsApi }/statsCentre/player/best/career?playerId=${ playerId }`,
            callback: response => setTopCareerData( response )
        } );
    }, [] );

    return (
        <StatsSection.Main>
            <StatsSection.Content>
                <StatsSection.ContentHeader>
                    <StatsSection.ContentHeaderHeading>
                        <div className="key-stats-and-performance__header-text-wrapper">
                            <strong>{ playerData?.seasonTotals?.matchesPlayed ?? '-' } <span className="u-hide-until-desktop">{ getTranslation( 'label.stats.matches' ) }</span></strong> <span className="u-hide-from-desktop">{ getTranslation( 'label.stats.matches' ) }</span> { getTranslation( 'label.stats.thisSeason' ) }
                        </div>
                        <span className="key-stats-and-performance__header-text-divider"></span>
                        <div className="key-stats-and-performance__header-text-wrapper">
                            <strong>{ playerData?.careerTotals?.matchesPlayed ?? '-' } <span className="u-hide-until-desktop">{ getTranslation( 'label.stats.matches' ) }</span></strong> <span className="u-hide-from-desktop">{ getTranslation( 'label.stats.matches' ) }</span> { getTranslation( 'label.stats.inCareer' ) }
                        </div>
                    </StatsSection.ContentHeaderHeading>
                    <StatsSection.ContentHeaderOptions>
                        <BenchmarkingExplainer />
                    </StatsSection.ContentHeaderOptions>
                </StatsSection.ContentHeader>
                <StatsSection.ContentBody>
                    { ( !playerData || !topSeasonData || !topCareerData ) ? (
                        <div className="key-stats-and-performance__loader">
                            <Loader />
                        </div>
                    ) : (
                        <>
                            { ( playerData.seasonAverages && playerData.careerAverages ) ? (
                                <KeyStatsAndPerformanceMain playerData={ playerData } topSeasonData={ topSeasonData } topCareerData={ topCareerData } />
                            ) : (
                                <div className="key-stats-and-performance__empty-state">
                                    <EmptyState />
                                </div>
                            ) }
                        </>
                    ) }
                </StatsSection.ContentBody>
            </StatsSection.Content>
        </StatsSection.Main>
    );
};

KeyStatsAndPerformance.propTypes = {
    seasonId: PropTypes.string.isRequired
};